var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50340_22323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8V5.46098C18 5.01895 17.8244 4.59503 17.5118 4.28247C17.1993 3.96991 16.7754 3.79431 16.3333 3.79431H4.66667C4.22464 3.79431 3.80072 3.96991 3.48816 4.28247C3.17559 4.59503 3 5.01895 3 5.46098V17.1276C3 17.5697 3.17559 17.9936 3.48816 18.3062C3.80072 18.6187 4.22464 18.7943 4.66667 18.7943H8",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.832 2.16663V3.5",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16797 2.16663V3.66647",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7227 17.8499C11.3704 18.7412 12.3179 19.369 13.3913 19.6178C14.4647 19.8666 15.5917 19.7197 16.5655 19.2041C17.5393 18.6886 18.2942 17.8389 18.6918 16.8113C19.0893 15.7837 19.1027 14.6472 18.7295 13.6105C18.3563 12.5738 17.6215 11.7066 16.6602 11.1683C15.6989 10.6299 14.5755 10.4565 13.4966 10.6799C12.4177 10.9033 11.4556 11.5086 10.7871 12.3845C10.1187 13.2604 9.78873 14.3481 9.85792 15.4477M9.85792 15.4477L9 14.5898M9.85792 15.4477L10.7158 14.5898",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4258 12.8726V15.1603L16.1416 16.8762",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 7.8,
    x2: 18,
    y2: 7.8,
    stroke: "white",
    strokeWidth: 1.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50340_22323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryV2);
export default __webpack_public_path__ + "static/media/historyV2.16c543d98473f1d3d57cf0c2aa05b267.svg";
export { ForwardRef as ReactComponent };